// currently depends on styles defined in _animations.scss
export function fadeIn(el) {
    const listener = function (e) {
        const target = e.target;
        target.classList.remove('fade-in');
        el.removeEventListener("animationend", listener);
    };
    el.addEventListener('animationend', listener);
    el.classList.remove('hidden');
    el.classList.add("fade-in");
}
export function fadeOut(el) {
    const listener = function (e) {
        const target = e.target;
        target.classList.remove("fade-out");
        target.classList.add('hidden');
        el.removeEventListener("animationend", listener);
    };
    el.addEventListener("animationend", listener);
    el.classList.add('fade-out');
}
